(() => {
  const cfg = window.A4E_REGION || {};
  if (!cfg || !cfg.currency || cfg.currency === 'EUR') return;

  const rate = Number(cfg.rate || 1);
  const locale = cfg.locale === 'cs' ? 'cs-CZ' : (cfg.locale === 'pl' ? 'pl-PL' : 'en-IE');
  const currency = cfg.currency;
  const fractionDigits = currency === 'CZK' ? 0 : 2;
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  });

  const parseNumber = (s) => {
    let value = String(s).replace(/\s/g, '');
    if (value.includes(',') && value.includes('.')) {
      if (value.lastIndexOf(',') > value.lastIndexOf('.')) value = value.replace(/\./g, '').replace(',', '.');
      else value = value.replace(/,/g, '');
    } else if (value.includes(',')) {
      const parts = value.split(',');
      value = parts.length === 2 && parts[1].length <= 2 ? value.replace(',', '.') : value.replace(/,/g, '');
    }
    return Number(value);
  };

  const convertText = (text) => {
    let out = text;

    out = out.replace(/€\s*([0-9][0-9\s.,]*)/g, (_, n) => {
      const eur = parseNumber(n);
      return Number.isFinite(eur) ? formatter.format(eur * rate) : _;
    });

    out = out.replace(/([0-9][0-9\s.,]*)\s*€/g, (_, n) => {
      const eur = parseNumber(n);
      return Number.isFinite(eur) ? formatter.format(eur * rate) : _;
    });

    out = out.replace(/EUR\s*([0-9][0-9\s.,]*)/gi, (_, n) => {
      const eur = parseNumber(n);
      return Number.isFinite(eur) ? formatter.format(eur * rate) : _;
    });

    out = out.replace(/([0-9][0-9\s.,]*)\s*EUR\b/gi, (_, n) => {
      const eur = parseNumber(n);
      return Number.isFinite(eur) ? formatter.format(eur * rate) : _;
    });

    if (currency === 'CZK' || currency === 'PLN') {
      out = out.replace(/\s*EUR\b/gi, '');
    }

    return out;
  };

  const selector = [
    '.price-item',
    '.totals__total-value',
    '.cart-item__old-price',
    '.cart-item__final-price',
    '.unit-price',
    '.cart-drawer .price',
    '.cart-item__price-wrapper > .price',
    '.predictive-search .price-item'
  ].join(',');

  const convertElement = (el) => {
    if (!el || el.dataset.a4eConverted === currency) return;
    if (el.children.length > 0 && !el.matches('.price-item')) return;
    const original = el.dataset.a4eEurText || el.textContent;
    if (!/[€]|EUR/i.test(original)) return;
    el.dataset.a4eEurText = original;
    el.textContent = convertText(original);
    el.dataset.a4eConverted = currency;
  };

  const scan = (root = document) => {
    root.querySelectorAll?.(selector).forEach(convertElement);
    if (root.matches?.(selector)) convertElement(root);
  };

  const addCheckoutNote = () => {
    const noteText = cfg.locale === 'cs'
      ? 'Ceny zobrazujeme orientačně v CZK. Kvůli současné platební bráně bude finální platba při checkoutu zpracována v EUR.'
      : 'Ceny wyświetlamy orientacyjnie w PLN. Ze względu na obecną bramkę płatniczą finalna płatność w checkout zostanie rozliczona w EUR.';
    const targets = document.querySelectorAll('.cart__footer, cart-drawer .drawer__footer');
    targets.forEach(target => {
      if (target.querySelector('.a4e-checkout-currency-note')) return;
      const note = document.createElement('p');
      note.className = 'a4e-checkout-currency-note';
      note.textContent = noteText;
      target.prepend(note);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    scan(document);
    addCheckoutNote();
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1) scan(node);
        }
      }
      scan(document);
      addCheckoutNote();
    });
    observer.observe(document.documentElement, {subtree:true, childList:true, characterData:false});
  });

  document.addEventListener('shopify:section:load', () => {
    scan(document);
    addCheckoutNote();
  });
})();